
export const calendarEventConstants = {
    CALENDAREVENT_CHANGE_VALUE: "CALENDAREVENT_CHANGE_VALUE",

    GET_CALENDAREVENT_STARTED: "GET_CALENDAREVENT_STARTED",
    GET_CALENDAREVENT_SUCCESS: "GET_CALENDAREVENT_SUCCESS",
    GET_CALENDAREVENT_FAILURE: "GET_CALENDAREVENT_FAILURE",

    GET_CALENDAREVENTS_STARTED: "GET_CALENDAREVENTS_STARTED",
    GET_CALENDAREVENTS_SUCCESS: "GET_CALENDAREVENTS_SUCCESS",
    GET_CALENDAREVENTS_FAILURE: "GET_CALENDAREVENTS_FAILURE",

    SEARCH_CALENDAREVENTS_STARTED: "SEARCH_CALENDAREVENTS_STARTED",
    SEARCH_CALENDAREVENTS_SUCCESS: "SEARCH_CALENDAREVENTS_SUCCESS",
    SEARCH_CALENDAREVENTS_FAILURE: "SEARCH_CALENDAREVENTS_FAILURE",

    CREATING_CALENDAREVENT_STARTED: "CREATING_CALENDAREVENT_STARTED",
    CREATING_CALENDAREVENT_SUCCESS: "CREATING_CALENDAREVENT_SUCCESS",
    CREATING_CALENDAREVENT_FAILURE: "CREATING_CALENDAREVENT_FAILURE",

    UPDATING_CALENDAREVENT_STARTED: "UPDATING_CALENDAREVENT_STARTED",
    UPDATING_CALENDAREVENT_SUCCESS: "UPDATING_CALENDAREVENT_SUCCESS",
    UPDATING_CALENDAREVENT_FAILURE: "UPDATING_CALENDAREVENT_FAILURE",

    DELETE_CALENDAREVENT_STARTED: "DELETE_CALENDAREVENT_STARTED",
    DELETE_CALENDAREVENT_SUCCESS: "DELETE_CALENDAREVENT_SUCCESS",
    DELETE_CALENDAREVENT_FAILURE: "DELETE_CALENDAREVENT_FAILURE",
};
